export default __webpack_public_path__ + "static/media/toshiba.cc47aaf7.png";